import React from 'react'
import { useSelector } from 'react-redux'
import TableTr from '../../tr'
import OrdersTableTdList from '../../OrdersTable/OrdersTableTdList'
import PreOrdersType from '../preOrdersType'
import { useTranslation } from 'react-i18next'

const PreOrdersDays = React.memo(({ activeRow, focusRow, tableHeadersStatic, handleClick, handleDbClick }) => {
	const { t } = useTranslation()
	const preOrdersToday = useSelector(store => store.order.preOrdersToday)
	const preOrdersDays = useSelector(store => store.order.preOrdersDays)
	const border = preOrdersToday.length > 0

	return (
		<>
			{preOrdersDays?.length > 0 &&
				<PreOrdersType border={border}>{t('order.preorders.other_days')}</PreOrdersType>}
			{preOrdersDays?.map((item, i) =>
				<TableTr key={i}
									onDoubleClick={() => handleDbClick(item, i, 'OTHER_DAYS')} onClick={() => handleClick(item, i, 'OTHER_DAYS')}
									isActive={focusRow && i === activeRow}
									disabled={item?.status?.status === 'CANCELED' || !!item?.zNumber}
									disabledStatus={!!item?.zNumber}
									name={item?.zNumber ? 'CLOSED' : item?.status?.status}
									className="row-tablet-cols-4 bold-lf-border">
					<OrdersTableTdList tableHeadersStatic={tableHeadersStatic} item={item} />
				</TableTr>)}
		</>
	)
})

PreOrdersDays.displayName = 'PreOrdersDays'
export default PreOrdersDays
